import React, { useState } from 'react';
import { ShouqiLineIcon, ZhankaiLineIcon } from '@kim/icon';
import loading from '@src/assets/images/agent_running.png';
import { Avatar } from '@src/components/common/avatar';
import { MdRender } from '@src/components/common/md-render';
import { getRelativeTime } from '@src/utils/date-format';
import {
  ImRole,
  IMessageItem,
  StreamStatus,
} from '@src/components/common/chat-list/type';
import styles from './index.module.less';
import classNames from 'classnames';

export const ThinkingBlock: React.FC<{
  streamStatus: StreamStatus;
}> = ({ streamStatus }) => {
  const [expanded, setExpanded] = useState(false);
  const isStreaming = [StreamStatus.READY, StreamStatus.STREAMING].includes(
    streamStatus,
  );
  return (
    <div
      className={classNames(styles.thinkingBlock, {
        [styles.thinkingBlockExpanded]: expanded,
      })}
    >
      <div className={styles.thinkingHeader}>
        <span
          className={classNames(styles.thinkingTitle, {
            [styles.thinkingTitleStreaming]: isStreaming,
          })}
        >
          {isStreaming && (
            <img src={loading} alt="" className={styles.thinkingLoading} />
          )}
          {isStreaming ? '正在思考...' : '已思考完成'}
        </span>
        {/* <button
        className={styles.thinkingToggle}
        type="button"
        aria-label={expanded ? '收起' : '展开'}
        style={hasContent ? undefined : { visibility: 'hidden' }}
      >
        {!expanded ? <ZhankaiLineIcon /> : <ShouqiLineIcon />}
      </button> */}
      </div>
    </div>
  );
};

export const MessageItem: React.FC<{
  message: IMessageItem;
  hideHeader?: boolean;
}> = ({ message, hideHeader }) => {
  if (message.role === ImRole.SYSTEM) {
    return <div className={styles.messageSystem}>{message.content}</div>;
  }
  return (
    <div
      className={classNames(styles.messageItem, {
        [styles.messageItemRight]: message.role === ImRole.SELF,
      })}
    >
      {!hideHeader && (
        <div className={styles.messageItemHeader}>
          <Avatar src={message.avatar} size={32} />
          <div className={styles.messageItemName}>{message.name}</div>
          <div className={styles.messageItemTime}>
            {getRelativeTime(message.timestamp || new Date())}
          </div>
        </div>
      )}
      {message.isShowThinking && (
        <ThinkingBlock streamStatus={StreamStatus.NONE} />
      )}
      <div className={styles.messageItemContent}>
        <MdRender source={message.content || ''} />
      </div>
    </div>
  );
};

export const SteamMessageItem: React.FC<{
  streamStatus: StreamStatus;
  message: IMessageItem;
  hideHeader?: boolean;
}> = ({ streamStatus, message, hideHeader }) => {
  return (
    <div className={styles.messageItem}>
      {!hideHeader && (
        <div className={styles.messageItemHeader}>
          <Avatar src={message.avatar} size={32} />
          <div className={styles.messageItemName}>{message.name ?? ''}</div>
          <div className={styles.messageItemTime}>
            {getRelativeTime(message.timestamp || new Date())}
          </div>
        </div>
      )}
      <ThinkingBlock streamStatus={streamStatus} />
      <div className={styles.messageItemContent}>
        <MdRender source={message.content || ''} />
      </div>
    </div>
  );
};
